import { NgModule } from '@angular/core';

import { NgxSpinnerModule } from 'ngx-spinner';
import { ButtonModule } from 'primeng/button';
import { ChipsModule } from 'primeng/chips';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TabViewModule } from 'primeng/tabview';
import { SharedModule } from '../shared/shared/shared.module';
import { BlocksRoutingModule } from './blocks-routing.module';
import { HomeComponent } from './home/home/home.component';
import { MenuComponent } from './menu/menu.component';
import { AppComponent } from './root/app.component';

import { AvatarModule } from 'primeng/avatar';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';

import { StyleClassModule } from 'primeng/styleclass';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TopNavBarComponent } from './top-nav-bar/top-nav-bar.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';
@NgModule({
  declarations: [AppComponent, HomeComponent, MenuComponent, TopNavBarComponent, NotificationSidebarComponent],
  imports: [
    SharedModule,
    DynamicDialogModule,
    DialogModule,
    BlocksRoutingModule,
    MenuModule,
    ButtonModule,
    OverlayPanelModule,
    InputTextModule,
    ChipsModule,
    TabViewModule,
    SidebarModule,
    RippleModule,
    AvatarModule,
    TranslateModule,
    StyleClassModule,
    NgxSpinnerModule.forRoot({
      type: 'ball-scale-multiple',
    }),
  ],
  exports:[AppComponent]
})
export class BlocksModule { }
